import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.error('Application error', error);
    return { hasError: true };
  }

  // hasErrorToggle = () => {
  //   this.setState((prev) => ({ hasError: !prev.hasError }));
  // };

  // componentDidUpdate(prevProps, prevState) {
  // const { hasError } = prevState;
  // if (hasError !== this.state.hasError && this.state.hasError) {
  // }
  // }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return <>{children({ hasError })}</>;
  }
}
